import axios, { AxiosResponse } from 'axios';
import api from './api';

const cdnCrawlerApi = axios.create({
  baseURL: process.env.VUE_APP_CDN_CRAWLER,
  headers: api.defaults.headers,
});

const getRealTime = async (
  payload: Services.Statistics.GetRealTime,
): Promise<AxiosResponse<Services.Statistics.Response.GetRealTime>> => {
  const {
    city,
    country,
    customerPlansId,
    eventHash,
    state,
    type,
  } = payload;

  let relativeUrl = 'cdncrawler-statistics/views-online';

  switch (type) {
    case 'city':
      relativeUrl = `${relativeUrl}/${type}/statistics/${customerPlansId}/${country}/${state}/${city}`;
      break;
    case 'country':
      relativeUrl = `${relativeUrl}/${type}/${customerPlansId}/${country}`;
      break;
    case 'state':
      relativeUrl = `${relativeUrl}/${type}/${customerPlansId}/${country}/${state}`;
      break;
    default:
      relativeUrl = `${relativeUrl}/${customerPlansId}`;
      break;
  }

  return cdnCrawlerApi.get(relativeUrl, { params: { video: eventHash } });
};

const getRegion = async (
  payload: Services.Statistics.GetRegion,
): Promise<AxiosResponse<Services.Statistics.Response.GetRegion>> => {
  const {
    beginDate: begin,
    city,
    country,
    customerPlansId,
    endDate: end,
    eventHash,
    filter,
    state,
    type,
  } = payload;

  let relativeUrl = 'cdncrawler-statistics/views-region/video';

  switch (type) {
    case 'city':
      relativeUrl = filter
        ? `${relativeUrl}/${type}/${filter}/${customerPlansId}/${eventHash}/${country}/${state}/${city}`
        : `${relativeUrl}/${type}/${customerPlansId}/${eventHash}/${country}/${state}/${city}`;
      break;
    case 'country':
      relativeUrl = filter
        ? `${relativeUrl}/${type}/${filter}/${customerPlansId}/${eventHash}/${country}`
        : `${relativeUrl}/${type}/${customerPlansId}/${eventHash}/${country}`;
      break;
    case 'state':
      relativeUrl = filter
        ? `${relativeUrl}/${type}/${filter}/${customerPlansId}/${eventHash}/${country}/${state}`
        : `${relativeUrl}/${type}/${customerPlansId}/${eventHash}/${country}/${state}`;
      break;
    default:
      relativeUrl = filter
        ? `${relativeUrl}/${filter}/${customerPlansId}/${eventHash}`
        : `${relativeUrl}/${customerPlansId}/${eventHash}`;
      break;
  }

  return cdnCrawlerApi.get(relativeUrl, { params: { begin, end } });
};

const getSimultaneous = async (
  payload: Services.Statistics.GetSimultaneous,
): Promise<AxiosResponse<Services.Statistics.Response.GetSimultaneous>> => {
  const {
    beginDate: begin,
    customerPlansId,
    endDate: end,
    eventHash,
    filter,
    timezone,
  } = payload;

  const relativeUrl = 'cdncrawler-statistics/simultaneous-viewers/video/'
    .concat(`${filter}/${customerPlansId}/${eventHash}`);

  return cdnCrawlerApi.get(relativeUrl, { params: { begin, end, timezone } });
};

const statistics = {
  getRealTime,
  getRegion,
  getSimultaneous,
};

export default statistics;
